var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{staticClass:"text-center",attrs:{"shrink":""}},[_c('h1',{staticClass:"title mt-10"},[_vm._v("Ошибка!")]),_c('p',[_vm._v("Ничего не найдено")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }